import { render, staticRenderFns } from "./TermsAlert.vue?vue&type=template&id=73360d3b"
import script from "./TermsAlert.vue?vue&type=script&lang=js"
export * from "./TermsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports